function Interactive({data}) {
    const { id, name, description, link_address} = data;
    return ( 
        <div key={id} className="w-60 px-4 pb-4">
            <div className="min-h-[100px]">
                <h3 className="font-Encode text-heading3 text-light-blue font-semibold pb-1">{name}</h3>
                <p className="font-Encode text-subheading pb-1">{description}</p>
            </div>
            <a className="font-Encode text-intro_paragraph font-bold text-[#333333] underline decoration-[#FF4766]" href={link_address} target="_blank" rel="noopener noreferrer">View Demo</a>
        </div>
     );
}

export default Interactive;